import Device from "../../init/device";
import { combineReducers } from "redux";
import { withProperties } from "../../utils";
import withConstantStateFactory from "../helpers/reducers/constant";

export default function state() {
  const NAME = 'viewport';
  const $state = Object.create(null);
  // const { dispatch } = this;

  const ConstantState = withConstantStateFactory({
    mobile: Device.isMobile,
    width: window.innerWidth, // This is not a constant, it can change due to viewport changes
    height: window.innerHeight, // This is not a constant, it can change due to viewport changes
    orientation: null // This is not a constant, it can change due to viewport changes
  });

  const Reducer = combineReducers({
    ...ConstantState
  });

  // Augment $state with properties
  withProperties($state, { NAME, Reducer });

  // TODO:
  // Setup observers for viewport inner dimensions and orientation
  // Also update the state accordingly based on observed changes.

  return (state = $state);
}
